import React from 'react';
import { Box, Flex, Text, Avatar, VStack } from '@chakra-ui/react';
import { Home } from 'lucide-react';
import { useBoardContext } from '../context/BoardContext';
import { useNavigate } from 'react-router-dom';
const TEAL = '#00897B';
const SIDEBAR_BG = '#C8E6C0';
const CELL_BG = '#F1FAF1';
const CELL_ACTIVE_BG = '#B2DFDB';
export const boardMembers = [{
  position: 'President',
  name: 'Tony Stark'
}, {
  position: 'Vice President',
  name: 'Steve Rogers'
}, {
  position: 'Pos 1',
  name: 'Vacant'
}, {
  position: 'Pos 2',
  name: 'Bruce Banner'
}, {
  position: 'Pos 3',
  name: 'Clint Barton'
}, {
  position: 'Pos 4',
  name: 'Vacant'
}, {
  position: 'Pos 5',
  name: 'Clint Barton'
}];
export function BoardSidebar() {
  const {
    selectedIndex,
    setSelectedIndex
  } = useBoardContext();
  const navigate = useNavigate();
  return <Box as="nav" bg={SIDEBAR_BG} w="290px" minW="290px" position="fixed" top="64px" left={0} bottom={0} zIndex={90} display="flex" flexDirection="column" overflowY="hidden" data-id="element-42">
      {/* User Box */}
      <Flex align="center" gap={3} px={4} py={4} borderBottom="1px solid rgba(0,137,123,0.25)" flexShrink={0} data-id="element-43">
        <Avatar name="Keith Price" bg="#7B1FA2" color="white" size="md" fontWeight="bold" getInitials={() => 'KP'} data-id="element-44" />
        <Box data-id="element-45">
          <Text fontWeight="bold" color={TEAL} fontSize="md" lineHeight="1.2" data-id="element-46">
            Keith Price
          </Text>
          <Text color={TEAL} fontSize="sm" opacity={0.85} data-id="element-47">
            zMagic Solutions
          </Text>
        </Box>
      </Flex>

      {/* Home nav item */}
      <Box flexShrink={0} pt={2} mb={2} data-id="element-48">
        <Flex align="center" gap={4} px={5} py={3} cursor="pointer" borderRadius="md" _hover={{
        bg: 'rgba(0,137,123,0.12)'
      }} onClick={() => navigate('/welcome')} role="button" tabIndex={0} onKeyDown={e => e.key === 'Enter' && navigate('/welcome')} data-id="element-49">
          <Box color={TEAL} flexShrink={0} data-id="element-50">
            <Home size={26} strokeWidth={1.8} data-id="element-51" />
          </Box>
          <Text color={TEAL} fontWeight="500" fontSize="md" data-id="element-52">
            Home
          </Text>
        </Flex>
      </Box>

      {/* Board member list */}
      <Box flex={1} overflowY="auto" px={3} pt={2} pb={2} sx={{
      '&::-webkit-scrollbar': {
        display: 'none'
      },
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }} data-id="element-53">
        <VStack align="stretch" spacing={1} data-id="element-54">
          {boardMembers.map((member, idx) => {
          const isSelected = idx === selectedIndex;
          return <Box key={idx} bg={isSelected ? CELL_ACTIVE_BG : CELL_BG} borderRadius="sm" px={3} py={1.5} borderLeft="3px solid" borderLeftColor={isSelected ? '#004D40' : TEAL} cursor="pointer" onClick={() => setSelectedIndex(idx)} _hover={{
            bg: isSelected ? CELL_ACTIVE_BG : '#E0F2E9'
          }} transition="background 0.15s" data-id="element-55">
                <Text fontSize="10px" fontWeight="600" color={isSelected ? '#004D40' : TEAL} textTransform="uppercase" letterSpacing="0.06em" lineHeight="1.3" data-id="element-56">
                  {member.position}
                </Text>
                <Text fontSize="sm" fontWeight={member.name === 'Vacant' ? 'normal' : 'semibold'} color={member.name === 'Vacant' ? 'gray.400' : isSelected ? '#004D40' : 'black'} fontStyle={member.name === 'Vacant' ? 'italic' : 'normal'} lineHeight="1.3" data-id="element-57">
                  {member.name}
                </Text>
              </Box>;
        })}
        </VStack>
      </Box>
    </Box>;
}